define('app-SearchResults/modules/modules',['./framework/module',
        './resultsList/module',
        './facets/module',
        './batBelt/module',
        './urlWatcher/module'],
        function (framework, searchResults, searchFacets, batBelt, urlWatcher) {
            return [
                urlWatcher, // load this first so the URL params are checked before we send off a query.
                framework,
                searchResults,
                searchFacets,
                batBelt
            ];
        });
